module.exports = __webpack_public_path__ + "static/assets/3cb3d6088140f0ae269324ac1a314b94.svg";